import { render, staticRenderFns } from "./ServiceTransport.vue?vue&type=template&id=b244026a&"
import script from "./ServiceTransport.vue?vue&type=script&lang=js&"
export * from "./ServiceTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports